<script setup>
// Sistema de iconos — SVG inline, 1em. Portado de components.jsx.
// El contenido interior se guarda como markup SVG; al asignarse via
// innerHTML sobre un <svg>, el navegador lo parsea en el namespace SVG.
defineOptions({ name: 'DsIcon', inheritAttrs: false });

defineProps({
  name: { type: String, required: true },
  size: { type: [Number, String], default: 16 },
  stroke: { type: [Number, String], default: 1.75 }
});

const paths = {
  check: '<polyline points="3.5 8.5 6.5 11.5 12.5 5" />',
  x: '<line x1="4" y1="4" x2="12" y2="12" /><line x1="12" y1="4" x2="4" y2="12" />',
  chevDown: '<polyline points="4 6 8 10 12 6" />',
  chevRight: '<polyline points="6 4 10 8 6 12" />',
  chevUp: '<polyline points="4 10 8 6 12 10" />',
  chevLeft: '<polyline points="10 4 6 8 10 12" />',
  sort: '<polyline points="5 7 8 4 11 7" /><polyline points="5 9 8 12 11 9" />',
  sortAsc: '<polyline points="5 7 8 4 11 7" />',
  sortDesc: '<polyline points="5 9 8 12 11 9" />',
  plus: '<line x1="8" y1="3" x2="8" y2="13" /><line x1="3" y1="8" x2="13" y2="8" />',
  search: '<circle cx="7" cy="7" r="4" /><line x1="10" y1="10" x2="13" y2="13" />',
  filter: '<polygon points="2.5 3.5 13.5 3.5 9.5 8.5 9.5 12.5 6.5 13.5 6.5 8.5" />',
  eye: '<path d="M2 8 C 4 4, 12 4, 14 8 C 12 12, 4 12, 2 8 Z" /><circle cx="8" cy="8" r="2" />',
  eyeOff: '<path d="M2 8 C 4 4, 12 4, 14 8 C 12 12, 4 12, 2 8 Z" /><line x1="3" y1="3" x2="13" y2="13" />',
  logout: '<path d="M9 3 H 4 V 13 H 9" /><polyline points="10 6 13 8 10 10" /><line x1="13" y1="8" x2="7" y2="8" />',
  user: '<circle cx="8" cy="6" r="2.5" /><path d="M3.5 13 C 4 10, 12 10, 12.5 13" />',
  refresh: '<path d="M3 8 A 5 5 0 0 1 13 8" /><polyline points="11 5 13 8 10 9" /><path d="M13 8 A 5 5 0 0 1 3 8" /><polyline points="5 11 3 8 6 7" />',
  activity: '<polyline points="2 8 5 8 7 4 9 12 11 8 14 8" />',
  alert: '<path d="M8 2 L 14 13 H 2 Z" /><line x1="8" y1="6" x2="8" y2="9" /><circle cx="8" cy="11" r="0.5" fill="currentColor" />',
  info: '<circle cx="8" cy="8" r="6" /><line x1="8" y1="7" x2="8" y2="11" /><circle cx="8" cy="5" r="0.5" fill="currentColor" />',
  dot: '<circle cx="8" cy="8" r="3" fill="currentColor" />',
  more: '<circle cx="4" cy="8" r="1" fill="currentColor" /><circle cx="8" cy="8" r="1" fill="currentColor" /><circle cx="12" cy="8" r="1" fill="currentColor" />',
  download: '<line x1="8" y1="3" x2="8" y2="11" /><polyline points="5 8 8 11 11 8" /><line x1="3" y1="13" x2="13" y2="13" />',
  copy: '<rect x="5" y="5" width="8" height="8" rx="1" /><path d="M3 11 V 3 H 11" />',
  settings: '<circle cx="8" cy="8" r="2" /><path d="M8 2 V 4 M 8 12 V 14 M 2 8 H 4 M 12 8 H 14 M 3.5 3.5 L 5 5 M 11 11 L 12.5 12.5 M 3.5 12.5 L 5 11 M 11 5 L 12.5 3.5" />',
  bell: '<path d="M4 11 V 7 A 4 4 0 0 1 12 7 V 11 L 13 12 H 3 Z" /><path d="M7 13 A 1.5 1.5 0 0 0 9 13" />',
  grid: '<rect x="2.5" y="2.5" width="4.5" height="4.5" /><rect x="9" y="2.5" width="4.5" height="4.5" /><rect x="2.5" y="9" width="4.5" height="4.5" /><rect x="9" y="9" width="4.5" height="4.5" />',
  list: '<line x1="3" y1="4" x2="13" y2="4" /><line x1="3" y1="8" x2="13" y2="8" /><line x1="3" y1="12" x2="13" y2="12" />',
  clock: '<circle cx="8" cy="8" r="6" /><polyline points="8 4 8 8 11 9" />',
  calendar: '<rect x="2.5" y="3.5" width="11" height="10" rx="1" /><line x1="2.5" y1="6" x2="13.5" y2="6" /><line x1="5" y1="2" x2="5" y2="5" /><line x1="11" y1="2" x2="11" y2="5" />',
  arrowUp: '<line x1="8" y1="13" x2="8" y2="3" /><polyline points="4 7 8 3 12 7" />',
  arrowDn: '<line x1="8" y1="3" x2="8" y2="13" /><polyline points="4 9 8 13 12 9" />',
  arrowR: '<line x1="3" y1="8" x2="13" y2="8" /><polyline points="9 4 13 8 9 12" />',
  trash: '<polyline points="3 4 13 4" /><path d="M5 4 V 13 H 11 V 4" /><line x1="6.5" y1="2.5" x2="9.5" y2="2.5" />',
  edit: '<path d="M3 11 L 3 13 L 5 13 L 12 6 L 10 4 Z" /><line x1="10" y1="4" x2="12" y2="6" />',
  db: '<ellipse cx="8" cy="4" rx="5" ry="1.5" /><path d="M3 4 V 8 C 3 9, 13 9, 13 8 V 4" /><path d="M3 8 V 12 C 3 13, 13 13, 13 12 V 8" />',
  server: '<rect x="2.5" y="3" width="11" height="4" rx="1" /><rect x="2.5" y="9" width="11" height="4" rx="1" /><circle cx="5" cy="5" r="0.5" fill="currentColor" /><circle cx="5" cy="11" r="0.5" fill="currentColor" />',
  cpu: '<rect x="4" y="4" width="8" height="8" rx="1" /><line x1="6" y1="1" x2="6" y2="4" /><line x1="10" y1="1" x2="10" y2="4" /><line x1="6" y1="12" x2="6" y2="15" /><line x1="10" y1="12" x2="10" y2="15" /><line x1="1" y1="6" x2="4" y2="6" /><line x1="1" y1="10" x2="4" y2="10" /><line x1="12" y1="6" x2="15" y2="6" /><line x1="12" y1="10" x2="15" y2="10" />',
  camera: '<path d="M2 5 H 5 L 6 3.5 H 10 L 11 5 H 14 V 12 H 2 Z" /><circle cx="8" cy="8.5" r="2.5" />',
  shield: '<path d="M8 2 L 13 4 V 8 C 13 11, 8 14, 8 14 C 8 14, 3 11, 3 8 V 4 Z" />',
  eyeOpen: '<path d="M2 8 C 4 4, 12 4, 14 8 C 12 12, 4 12, 2 8 Z" /><circle cx="8" cy="8" r="2" />',
  lock: '<rect x="3.5" y="7" width="9" height="6" rx="1" /><path d="M5.5 7 V 5 A 2.5 2.5 0 0 1 10.5 5 V 7" />',
  mail: '<rect x="2" y="3.5" width="12" height="9" rx="1" /><polyline points="2 4 8 9 14 4" />',
  external: '<polyline points="9 3 13 3 13 7" /><line x1="13" y1="3" x2="7" y2="9" /><path d="M11 9 V 12 H 4 V 5 H 7" />',
  branch: '<circle cx="4" cy="4" r="1.5" /><circle cx="4" cy="12" r="1.5" /><circle cx="12" cy="4" r="1.5" /><path d="M4 5.5 V 10.5" /><path d="M12 5.5 V 7 A 2 2 0 0 1 10 9 H 5.5" />',
  layers: '<polygon points="8 2 14 5 8 8 2 5" /><polyline points="2 8 8 11 14 8" /><polyline points="2 11 8 14 14 11" />',
  file: '<path d="M4 2 H 9 L 12 5 V 14 H 4 Z" /><polyline points="9 2 9 5 12 5" />',
  sun: '<circle cx="8" cy="8" r="3" /><line x1="8" y1="1.5" x2="8" y2="3" /><line x1="8" y1="13" x2="8" y2="14.5" /><line x1="1.5" y1="8" x2="3" y2="8" /><line x1="13" y1="8" x2="14.5" y2="8" /><line x1="3.5" y1="3.5" x2="4.6" y2="4.6" /><line x1="11.4" y1="11.4" x2="12.5" y2="12.5" /><line x1="3.5" y1="12.5" x2="4.6" y2="11.4" /><line x1="11.4" y1="4.6" x2="12.5" y2="3.5" />',
  moon: '<path d="M13 9.5 A 5.5 5.5 0 1 1 6.5 3 A 4.3 4.3 0 0 0 13 9.5 Z" />'
};
</script>

<template>
  <!-- eslint-disable vue/no-v-html — `paths` es markup SVG estático del propio
       componente, no entrada de usuario. -->
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    v-bind="$attrs"
    v-html="paths[name] || ''"
  />
</template>
